import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import classnames from 'classnames'
import styled from 'styled-components'
import shortid from 'shortid'
import {
  CustomInput,
  Form,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
} from 'reactstrap'
import moment from '../../lib/moment.js'

import { status, url } from '../../constants'

class ClientForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: '1',
    }
  }
  render() {
    return (
      /* eslint no-underscore-dangle: 0 */
      <Background>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={ classnames({ active: this.state.activeTab === '1' }) }
              onClick={ () => {} }
            >
              Client Information
            </NavLink>
          </NavItem>
          <Image
            src={ url }
            onClick={ get(this.props, 'create') ? this.props.cancelForm : this.props.showDiscard }
          />
        </Nav>
        <TabContent activeTab={ this.state.activeTab } >
          <TabPane tabId="1">
            <RowCon>
              <Col sm="12">
                <Form onSubmit={ (e) => e.preventDefault() }>
                  <FormGroup>
                    <Container >
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 4 }>
                          <Label >Client Name</Label>
                        </Col>
                        <Col sm={ 8 }>
                          <InputField
                            name="name"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            placeholder="Enter Client Name"
                            value={ get(this.props, 'name') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 4 }>
                          <Label >Client Name (TH)</Label>
                        </Col>
                        <Col sm={ 8 }>
                          <InputField
                            name="name_th"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            placeholder="Enter Client Name"
                            value={ get(this.props, 'name_th') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 4 }>
                          <Label >Address</Label>
                        </Col>
                        <Col sm={ 8 }>
                          <InputField
                            name="address"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            placeholder="Enter Client Address"
                            value={ get(this.props, 'address') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 4 }>
                          <Label >Contact Name</Label>
                        </Col>
                        <Col sm={ 8 }>
                          <InputField
                            name="contact_name"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            placeholder="Enter Contact Name"
                            value={ get(this.props, 'contact_name') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 4 }>
                          <Label >Contact position</Label>
                        </Col>
                        <Col sm={ 8 }>
                          <InputField
                            name="contact_position"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            placeholder="Enter Contact Position"
                            value={ get(this.props, 'contact_position') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 4 }>
                          <Label >Contact phone</Label>
                        </Col>
                        <Col sm={ 8 }>
                          <InputField
                            name="contact_phone"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            placeholder="Enter Contact Phone"
                            value={ get(this.props, 'contact_phone') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 4 }>
                          <Label >Contact email</Label>
                        </Col>
                        <Col sm={ 8 }>
                          <InputField
                            name="contact_email"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            placeholder="Enter Contact Email"
                            value={ get(this.props, 'contact_email') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      {
                        get(this.props, 'create') === undefined &&
                        <Row style={ { marginTop: 10 } }>
                          <Col sm={ 4 }><Label>Status</Label></Col>
                          <Col sm={ 8 }>
                            <CustomInputField
                              type="select"
                              id="is_active"
                              name="is_active"
                              disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                              value={ get(this.props, 'is_active') }
                              onChange={ this.props.handleInput }
                            >
                              {
                                status.map((s) =>
                                  <option key={ shortid() } value={ s.value }>{ s.label }</option>)
                              }
                            </CustomInputField>
                          </Col>
                        </Row>
                      }
                      {
                        get(this.props, 'create') === undefined &&
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 4 }><Label>Modified Date</Label></Col>
                            <Col sm={ 8 }>
                              <p>{ get(this.props, 'updated') ? moment(get(this.props, 'updated')).format('DD/MM/YYYY') : '-' }</p>
                            </Col>
                          </Row>
                      }
                      {
                        get(this.props, 'create') === undefined &&
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 4 }><Label>Modified By</Label></Col>
                            <Col sm={ 8 }>
                              <p>{ get(this.props, 'updated_by') ? get(this.props, 'updated_by') : '-' }</p>
                            </Col>
                          </Row>
                      }
                    </Container>
                  </FormGroup>
                  <Right>
                    { get(this.props, 'button') }
                  </Right>
                </Form>
              </Col>
            </RowCon>
          </TabPane>
        </TabContent>
      </Background>
    )
  }
}

ClientForm.propTypes = {
  handleInput: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}

export default ClientForm

const RowCon = styled(Row)`
  overflow-y: auto;
  max-height: calc(100vh - 220px);
`
const Right = styled.div`
  background-color: white;
  padding: 10px;
  text-align: right;
`
const Background = styled.div`
  background-color: white;
  padding: 10px;
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
`
const InputField = styled(Input)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
`
const Image = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 10px;
`
const CustomInputField = styled(CustomInput)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
`



// WEBPACK FOOTER //
// ./src/components/client/form.js